// ----------------------------------------------------------------------
// V2 Modern Progress Styling

import { alpha } from '@mui/material/styles';

export default function Progress() {
  const primaryMain = '#7635dc';
  const primaryLight = '#9b6def';

  return {
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          height: 6,
          borderRadius: 3,
          overflow: 'hidden'
        },
        bar: {
          borderRadius: 3
        },
        colorPrimary: {
          backgroundColor: alpha(primaryMain, 0.1),
          '& .MuiLinearProgress-bar': {
            background: `linear-gradient(90deg, ${primaryMain} 0%, ${primaryLight} 100%)`
          }
        },
        buffer: {
          backgroundColor: 'transparent'
        }
      }
    },
    MuiCircularProgress: {
      styleOverrides: {
        colorPrimary: {
          color: primaryMain
        }
      }
    }
  };
}
